import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { Tabs, TabsContent, TabsList, TabsTrigger, } from 'Components/primitives/tabs';
import { buildStaticId } from 'Components/utils/buildStaticId';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnTabs',
    props: /*@__PURE__*/ _mergeModels({
        tabs: { type: Array, required: true }
    }, {
        "modelValue": { type: String, ...{ required: true } },
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const modelValue = _useModel(__props, "modelValue");
        function getTabValue(tab) {
            if (tab.id)
                return tab.id;
            // Fallback for legacy component usage.
            return tab.value;
        }
        /** Static ID for Katalon tests. Uses localized label. */
        function getStaticId(tab) {
            return buildStaticId('en-tabs', tab.label, true);
        }
        const __returned__ = { props, modelValue, getTabValue, getStaticId, get Tabs() { return Tabs; }, get TabsContent() { return TabsContent; }, get TabsList() { return TabsList; }, get TabsTrigger() { return TabsTrigger; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
